import {KTIcon} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {UsersListFilter} from './UsersListFilter'
import {useLocation, useNavigate} from 'react-router-dom'
import scanCreditCard from '../../../../../../../assets/images/scan_credit-card.png'
import api from '../../../../../../utils/Api'
import {ConfirmModal} from '../../../../../../components/Modals'
import {useState, useRef} from 'react'
import Spinner from 'react-bootstrap/Spinner';
import {useAuth}  from '../../../../../auth/core/Auth'

const UsersListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const [modal, setModal] = useState<any>({show: false, title: '', content: '', confirmText: ''})
  const cardReaderActionUrl = useRef('')
  const [reading, setReading] = useState(false)
  const {can} = useAuth()

  const openAddUserModal = () => {
    setItemIdForUpdate(null)
  }
  const navigate = useNavigate()
  const location = useLocation()
  const isInExpensePurchaseOrderAssetPage = location.pathname.includes("expense-purchase-asset-order");

  return (
    <>
      <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
        {/*<UsersListFilter />*/}

        {/* begin::Export */}
        {/*<button type='button' className='btn btn-light-primary me-3'>
          <KTIcon iconName='exit-up' className='fs-2' />
          Export
        </button>*/}
        {/* end::Export */}

        {/* begin::Add user */}
        {can('accounting_purchase_order_create') &&
          <button type='button' className='btn btn-primary' onClick={()=>navigate(`/expense-purchase${isInExpensePurchaseOrderAssetPage ? '-asset' : ''}-order/create`)}>
            <KTIcon iconName='plus' className='fs-2' />
            {isInExpensePurchaseOrderAssetPage ? 'สร้างใบสั่งซื้อสินทรัพย์' : 'สร้างใบสั่งซื้อ'}
          </button>
        }
        {/* end::Add user */}
      </div>
      <ConfirmModal
        show={modal.show}
        confirmVariant={'primary'}
        title={modal.title}
        content={modal.content}
        confirmText={modal.confirmText}
        onHide={() => setModal({...modal, show: false})}
        onConfirm={()=>{
          if (cardReaderActionUrl.current) {
            navigate(cardReaderActionUrl.current)
          }
        }}
      />
    </>
  )
}

export {UsersListToolbar}
